import React from 'react';
import "../../node_modules/flag-icons/css/flag-icons.min.css";
import {
  Select,
  MenuItem,
  ListItemIcon,
  ListItemText,
  FormControl,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DEFAULT_LANGUAGE, LANGUAGE_ITEM_LIST } from '../config/constant';
import { useLocalization } from '../LocalizationProvider';

const useStyles = makeStyles({
  flagIcon: {
    width: 20,
    marginRight: 8,
  },
});

const languages = LANGUAGE_ITEM_LIST

const LanguageSelector = () => {
  const { language, setLanguage } = useLocalization();
  const classes = useStyles();

  const selectedLang = languages.some((lang) => lang.code === language)
    ? language
    : DEFAULT_LANGUAGE;

  const handleChange = (event) => {
    setLanguage(event.target.value);
  }

  const selectedLanguage = languages.find(lang => lang.code === selectedLang);

  return (
    <FormControl variant="outlined" size="small">
      {/* <InputLabel id="language-select-label">Language</InputLabel> */}
      <Select
        labelId="language-select-label"
        value={selectedLang}
        onChange={handleChange}
        label=""
        renderValue={() => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span className={`fi fi-${selectedLanguage.flag}`} style={{ width: 20, marginRight: 12 }}></span>
            {selectedLanguage.label}
          </div>
        )}
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            <ListItemIcon>
              <span className={`fi fi-${lang.flag}`}></span>
            </ListItemIcon>
            <ListItemText primary={lang.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;
